import { PureComponent } from 'react';

import './Feedback-Styles.css';
import Trigger from './Trigger';
import { User } from 'shared/state/misc/oidc';

export interface FeedBackProps {
  value: FeedbackAttributes;
  siteId: number;
  siteName: string;
  user?: User;
}
class Feedback extends PureComponent<FeedBackProps> {
  render() {
    const { value, siteId, siteName, user } = this.props;
    const {
      feedbackEnable,
      enableFeedbackTypes,
      specifyEmailPerFeedbackType,
      allFeedbackTypeEmailValidation,
      allFeedbackTypeEmailList,
      issueFeedbackTypeEmailValidation,
      issueFeedBackTypeEmailList,
      ideaFeedbackTypeEmailValidation,
      ideaFeedbackTypeEmailList,
      bugFeedbackTypeEmailValidation,
      bugFeedbackTypeEmailList,
      feedbackStyle,
      feedbackButtonColor,
      fontColor,
      fontSize,
      fontFamily,
      formFields,
      feedbackAuthentication,
      feedbackButtonPosition,
    } = value;

    const feedbackTypesEnabled = enableFeedbackTypes ?? false;
    const feedbackTypes = feedbackTypesEnabled
      ? ['Issue', 'Idea', 'Other']
      : [];
    const showFeedbackButton = () => {
      if (!feedbackTypesEnabled) {
        return feedbackEnable;
      }

      if (feedbackTypesEnabled && specifyEmailPerFeedbackType) {
        return (
          feedbackEnable &&
          (issueFeedbackTypeEmailValidation ?? '') === '' &&
          (ideaFeedbackTypeEmailValidation ?? '') === '' &&
          (bugFeedbackTypeEmailValidation ?? '') === ''
        );
      } else {
        return feedbackEnable && (allFeedbackTypeEmailValidation ?? '') === '';
      }
    };

    const feedbackContent = (
      <>
        {showFeedbackButton() && (
          <div
            data-test-id="feedback-trigger-container"
            className="frf-feedback-container"
            style={{ zIndex: 100000 }}
          >
            <Trigger
              feedbackTypes={feedbackTypes}
              enableFeedbackTypes={feedbackTypesEnabled}
              buttonColor={feedbackButtonColor ?? '#6a35ff'}
              textColor={fontColor ?? '#000000'}
              hoverBorderColor={feedbackButtonColor ?? '#6a35ff'}
              fontFamily={fontFamily ?? 'OptumSans'}
              fontSize={fontSize ?? '16'}
              issueFeedBackTypeEmailList={
                specifyEmailPerFeedbackType
                  ? issueFeedBackTypeEmailList ?? ''
                  : allFeedbackTypeEmailList ?? ''
              }
              ideaFeedbackTypeEmailList={
                specifyEmailPerFeedbackType
                  ? ideaFeedbackTypeEmailList ?? ''
                  : allFeedbackTypeEmailList ?? ''
              }
              bugFeedbackTypeEmailList={
                specifyEmailPerFeedbackType
                  ? bugFeedbackTypeEmailList ?? ''
                  : allFeedbackTypeEmailList ?? ''
              }
              allFeedbackTypeEmailList={allFeedbackTypeEmailList ?? ''}
              specifyEmailPerFeedbackType={specifyEmailPerFeedbackType}
              feedbackStyle={feedbackStyle ?? 'Pinned Tab'}
              feedbackButtonPosition={feedbackButtonPosition}
              formfields={formFields ?? []}
              postSubmitButtonMsg={'Thanks for feedback'}
              submitButtonMsg={'Send Feedback'}
              zIndex={100000}
              siteId={siteId}
              siteName={siteName}
            />
          </div>
        )}
      </>
    );
    if (feedbackAuthentication) {
      return user && feedbackContent;
    } else {
      return feedbackContent;
    }
  }
}

export default Feedback;
